import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var AccountantSvg = function AccountantSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2 2.249h19.995v5.976h-1.5V3.752H3.5V14.27h6.495v1.502H2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.315 5.54a3.745 3.745 0 0 1 4.087.814L14.34 7.417A2.25 2.25 0 0 0 10.5 9.01H9a3.76 3.76 0 0 1 2.315-3.47M19.745 11.731h-1.5v1.503h1.5zM15.245 16.239h-1.5v1.502h1.5zM17.495 16.239h-1.5v1.502h1.5zM18.245 16.239h1.5v1.502h-1.5zM13.745 18.242h1.5v1.503h-1.5zM17.495 18.242h-1.5v1.503h1.5zM18.245 18.242h1.5v1.503h-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.495 9.728h10.5v12.521h-10.5zm1.5 1.502v2.505h7.5V11.23zm0 9.517v-5.51h7.5v5.51z",
    clipRule: "evenodd"
  }));
};
export var Accountant = function Accountant(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: AccountantSvg
  }));
};